import React from 'react';
import { Box } from '@mui/material';
import calorieScienceInvoiceLogo from '@/assets/images/menu-bar-logo.svg';

interface InvoiceLogoHeaderProps {
  clinicLogoUrl?: string | null;
}

const InvoiceLogoHeader: React.FC<InvoiceLogoHeaderProps> = ({ clinicLogoUrl }) => {
  const clinicLogoSrc = clinicLogoUrl?.trim();

  return (
    <Box
      sx={{
        minHeight: 64,
        px: 3,
        py: 1.75,
        bgcolor: '#fff',
        borderBottom: '1px solid #f3f4f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Box
        component="img"
        src={calorieScienceInvoiceLogo}
        alt="CalorieScience logo"
        sx={{
          display: 'block',
          width: 162,
          height: 46.8,
          maxWidth: 162,
          maxHeight: 46.8,
          objectFit: 'contain',
          objectPosition: 'left center',
          flexShrink: 0,
          imageRendering: 'auto',
        }}
      />
      {clinicLogoSrc ? (
        <Box
          component="img"
          src={clinicLogoSrc}
          alt="Clinic logo"
          sx={{
            display: 'block',
            width: 216,
            height: 62.4,
            maxWidth: 216,
            maxHeight: 62.4,
            objectFit: 'contain',
            objectPosition: 'right center',
            minWidth: 0,
            ml: 'auto',
          }}
        />
      ) : null}
    </Box>
  );
};

export default InvoiceLogoHeader;
